import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { on } from '@ember/modifier'
import t from 'ember-intl/helpers/t'

interface Signature {
  Element: HTMLButtonElement
}

const historyBack = () => history.back()

export const PageHeaderBackButton: TOC<Signature> = <template>
  <button type="button" {{on "click" historyBack}} ...attributes>
    <PhosphorIcon @icon="phosphor-caret-left-bold" class="h-3 w-3" />
    <span class="underline">{{t "back"}}</span>
  </button>
</template>
